import {useState} from 'react'
import {useNavigate} from 'react-router-dom';
import logoBabita from '../assets/imgs/logoBabita.png'
import userIcon from '../assets/imgs/userIcon.png'
import lockIcon from '../assets/imgs/lockIcon.png'
import smileEmoji from '../assets/imgs/logoBabita.png'
import '../assets/css/colors.css'
import '../assets/css/Principais.css'
import '../assets/css/fonts.css'
import '../assets/css/login.css'

import GlobalVar from './subComponents/GlobalVar.jsx' //variaveis globais
import { LoginUser } from './funcionalidades/bancoGet'
import Swal from 'sweetalert2'
import CryptoJS from 'crypto-js';


//var windowWidth = window.screen.availWidth;
var windowHeight = window.screen.availHeight;

function trataEnter(event, logar) {
    if (event.key === 'Enter') {
        logar()
    }
  }

function encriptaDado(dado){
    return CryptoJS.AES.encrypt(dado, 'T_cB@b0918Revend').toString()
}

function getLogin(usuario,senha, navigate){
    LoginUser({US: encriptaDado(usuario), PAS: encriptaDado(senha)})
        .then(resp=>{
            if(resp.Error){
                Swal.fire({
                    icon: "warning",
                    title: "Algo deu errado",
                    text: resp.Error
                  });
            }else{
                GlobalVar.setSessionStorage('VALD',{US: encriptaDado(usuario), PAS: encriptaDado(senha)})
                GlobalVar.setSessionStorage('usuario',resp)
                Swal.fire({
                    imageUrl: `${smileEmoji}`,
                    title: "Seja Bem Vindo(a)!",
                    text: resp.nomeusu
                  })
                  .then(()=>navigate("/Carregando"))
            }
        })
        .catch(()=>{Swal.fire({title: 'Algo deu errado', text:"Sistema Indisponível!", icon: "error"})})
}


export default function Login(props){

    const [usuario, setUsuario] = useState('');
    const [senha, setSenha] = useState('');
    const navigate = useNavigate();

    const usuarioStorage = GlobalVar.getSessionStorage('usuario')

    if (usuarioStorage){
        sessionStorage.clear();
    }

    return <>

        <div className="containerPrincipal centerView loginpage" style={{minHeight: "100vh", maxHeight: windowHeight,
    justifyContent: 'space-between'}}>

        <div className='imageEsquerda centerView'>
            <div className='logoEsq'></div>
            </div>
    <div className='loginContainer'>
            {/* LOGO BABITA */}
            <div className="centerView" style={{width:'100%', height: 'fit-content'}}> 
                    <img 
                    alt="logoBabita"
                    className='logoBabita'
                    src={logoBabita} />
            </div>


            {/* TITULO FORNECEDORES */}
            <p
            className='beatyFont subTitle'>Encomenda Babita</p>


            {/* ICONE USUARIO */}
            <div className='loginESenhaV'>
                <img 
                    alt="usuarioIcone"
                    className='imageLogineSenha'
                    src={userIcon} />

                <p style={{textAlign: "center", color: "#000000"}}>Usuário</p>

            </div>

            {/* INPUT USUARIO */}
            <input className='inputLogin'
            value={usuario}
            onChange = { (event) => {setUsuario(event.target.value)}}
            />


            {/* ICONE SENHA */}
            <div className='loginESenhaV' style={{marginTop: 2}}>
                <img 
                    alt="senhaIcone"
                    className='imageLogineSenha'
                    src={lockIcon} />

                <p style={{margin: 0, padding: 0, color: "#000000"}}>Senha</p>
                
            </div>

            {/* INPUT SENHA */}
            <input className='inputLogin'
            value={senha}
            type="password"
            onChange  = { (event) => setSenha(event.target.value)}
            onKeyDown = {event => trataEnter(event, ()=>getLogin(usuario,senha, navigate))}
            />



            {/* BOTAO LOGIN   styleTextBtn*/}
            
            <div className='styleButton styleTextBtn' onClick={()=>{getLogin(usuario,senha, navigate)}}>Login</div>
            
            </div>
        </div>
    </>
}